var render = function render(_c,_vm){return _c('div',{staticClass:"v-image-skeleton",style:({ height: _vm.props.height ? `${_vm.props.height}px` : 'auto' })})
}
var staticRenderFns = []

export { render, staticRenderFns }